import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { AlertType } from "src/app/utils/alert.utils";
import { AlertModule } from "@storeblocks/alert-ng";

export enum AlertKey {
  Dashboard = "dashboard",
  PensionPlan = "pension-plan",
  Contracts = "contracts",
}

export interface InfoMessage {
  key: AlertKey;
  showMessage: boolean;
  type: AlertType;
  heading: string;
  innerHTML: string;
  closeButtonLabel: string;
}

@Component({
  selector: "app-information-message",
  template: `
    @if (message()?.showMessage) {
      <section class="mb-16">
        <stb-alert
          [surfaceVariant]="'surface-1'"
          [rebrand]="true"
          [heading]="message()!.heading"
          width="fluid"
          [type]="message()!.type"
        >
          <div [innerHTML]="message()!.innerHTML"></div>
        </stb-alert>
      </section>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AlertModule],
})
export class InformationMessageComponent {
  readonly message = input<InfoMessage>();
}
